export const TAG_RULE: ValidationRule = {
  id: 'jps-tag',
  strict: true,
  fields: {
    id: {
      field: 'id',
      type: 'string',
      mandatory: true,
      label: {
        ja: 'ID',
        en: 'ID'
      }
    },
    label: {
      field: 'label',
      type: 'object',
      mandatory: false,
      jaMandatory: true,
      objRuleName: 'jps-lang_string',
      label: {
        ja: 'タグ名',
        en: 'Tag'
      }
    },
    description: {
      field: 'description',
      type: 'object',
      mandatory: false,
      allowMultiline: true,
      objRuleName: 'jps-lang_string',
      label: {
        ja: '説明',
        en: 'Description'
      }
    },
    equivalence: {
      field: 'equivalence',
      type: 'array',
      mandatory: false,
      arraySubType: 'string',
      label: {
        ja: '語彙',
        en: 'Equivalence'
      }
    },
    type: {
      field: 'type',
      type: 'string',
      mandatory: false,
      enumKey: 'jps-tag_type',
      label: {
        ja: 'タイプ',
        en: 'Type'
      }
    }
  }
  , enums: {
    'jps-tag_type': TAG_TYPE_DEF
  }
}
